<template>
    <div class="d-flex justify-space-between">
        <v-form class="d-flex" ref="form" @submit.prevent="save">
            <p class="number my-0 pa-1 mr-2" style="height: 27px">
                {{ number }}
            </p>
            <div>
                <v-text-field
                    color="primary"
                    class="py-0 mt-n1"
                    label="Add Title"
                    name="title"
                    v-validate="'required|name'"
                    :error-messages="errors.first('title')"
                    validate-on-blur
                    v-model="item.title"
                    single-line
                    hide-details
                    aria-required
                    required
                />

                <v-text-field
                    color="primary"
                    label="Enter quantity"
                    validate-on-blur
                    v-model="item.quantity"
                    v-validate="'required'"
                    name="quantity"
                    :error-messages="errors.first('quantity')"
                    hide-details
                    aria-required
                    required
                    single-line
                    min="1"
                    step="1"
                    type="number"
                    suffix="hours"
                />
            </div>
        </v-form>
        <div>
            <v-text-field
                label="Enter price"
                v-model="item.price"
                name="price"
                :error-messages="errors.first('price')"
                color="primary"
                class="mt-4 ml-5 pl-3 pl-md-0 pt-md-0 ml-md-0 mt-md-n1"
                prefix="$"
                id="cost"
                validate-on-blur
                hide-details
                min="1"
                aria-required
                v-validate="'required'"
                required
                single-line
                type="number"
            ></v-text-field>
            <div class="text-right mt-4">
                <v-btn
                    class="red--text text-none px-0 subtitle-1"
                    text
                    @click="$emit('cancel')"
                >
                    Cancel
                </v-btn>
                <v-btn
                    class="primary--text text-none px-0 subtitle-1"
                    text
                    type="submit"
                    @click.prevent="save"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            item: {},
        }
    },
    props: {
        index: Number,
        selectedItem: Object,
    },
    created() {
        if(!!this.selectedItem) {
            this.item = this.selectedItem;
        }
    },
    computed: {
        number() {
            const { index } = this;
            if(index > 9) return index;
            return `0${index}`;
        },
    },
    methods: {
        save() {
            const vm = this;
            vm.$validator.validateAll().then(submitIfValid);

            function submitIfValid(formIsValid) {
                if(formIsValid) {
                    vm.$emit('add', {
                        ...vm.item,
                        id: vm.index,
                    });
                }
            }
        }
    },
}
</script>

<style scoped>
.number {
    background-color: rgba(196, 196, 196, 0.4);
}

.v-text-field {
    max-width: 150px;
}
</style>